import {Logout} from "@mui/icons-material";
import {Avatar, Divider, IconButton, ListItemIcon, Menu, MenuItem, Stack, Tooltip, Typography} from "@mui/material";
import React, {useState} from "react";
import {useLogout} from "../auth";
import {useLocalization} from "@smalox/shared";
import {useUser} from "../user";

export function UserMenu() {
	const {t} = useLocalization();
	const user = useUser();
	const logout = useLogout();
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const displayName = [user.givenName, user.familyName]
		.filter(name => name?.trim())
		.join(" ") || user.displayName || user.email || "?";
	const initials = (user.givenName?.trim()?.[0] || user.displayName?.trim()?.[0] || "?").toUpperCase();

	function handleOpen(event: React.MouseEvent<HTMLElement>) {
		setAnchorEl(event.currentTarget);
	}

	function handleClose() {
		setAnchorEl(null);
	}

	function handleLogout() {
		handleClose();
		logout();
	}

	return (
		<>
			<Tooltip title={displayName}>
				<IconButton onClick={handleOpen} size="small" aria-label={displayName}>
					<Avatar sx={{width: 32, height: 32, fontSize: 14}}>
						{initials}
					</Avatar>
				</IconButton>
			</Tooltip>
			<Menu
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={handleClose}
				transformOrigin={{horizontal: "right", vertical: "top"}}
				anchorOrigin={{horizontal: "right", vertical: "bottom"}}
			>
				<MenuItem disabled sx={{opacity: "1 !important"}}>
					<Stack>
						<Typography variant="subtitle2">{displayName}</Typography>
						{user.email && <Typography variant="caption" color="text.secondary">{user.email}</Typography>}
					</Stack>
				</MenuItem>
				<Divider />
				<MenuItem onClick={handleLogout}>
					<ListItemIcon>
						<Logout fontSize="small" />
					</ListItemIcon>
					{t("logout.title")}
				</MenuItem>
			</Menu>
		</>
	);
}
